import type { AvatarImage } from "~/modules/image/api/avatarImage/avatarImageTypes.ts";
import type {
	MonthlyClosingCloseRequest,
	MonthlyClosingNonProjectPart,
	MonthlyClosingReopenRequest,
	MonthlyClosingStaffingPart,
} from "~/modules/timeTracking/api/monthlyClosing/monthlyClosingTypes.ts";

export type ClosingProjectGroup = {
	projectId: string;
	projectName: string;
	companyAvatarImage?: AvatarImage | null;
	staffings: MonthlyClosingStaffingPart[];
};

export type ClosingListProps = {
	groups: ClosingProjectGroup[];
	nonProject: MonthlyClosingNonProjectPart;
	onCloseRequest: (request: MonthlyClosingCloseRequest) => void;
	onReopenRequest: (request: MonthlyClosingReopenRequest) => void;
};

export const nonProjectTitle = "Intern-, Sales- und Teilzeiterfassungen";

export const nonProjectLabel = "die Intern-, Sales- und Teilzeiterfassungen";
